import { render, staticRenderFns } from "./CACA-Basic.vue?vue&type=template&id=640f7c56&scoped=true"
import script from "./CACA-Basic.vue?vue&type=script&lang=js"
export * from "./CACA-Basic.vue?vue&type=script&lang=js"
import style0 from "./CACA-Basic.vue?vue&type=style&index=0&id=640f7c56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f7c56",
  null
  
)

export default component.exports